import React, {PropsWithChildren, useState} from "react";
import styles from "./AccordionItem.module.scss";

export type AccordionItemProps = {title: string; active?: boolean; sticky?: boolean};

const AccordionItem: React.FC<PropsWithChildren<AccordionItemProps>> = ({
  title,
  children,
  active = false,
  sticky = false,
}) => {
  const [isActive, setIsActive] = useState(active);
  const onHeadClick = () => {
    setIsActive(!isActive);
  };

  return (
    <div className={`${styles.wrapper} ${isActive ? styles.active : ""}`}>
      <div className={`${styles.head} ${sticky ? styles.fixed : ""}`} onClick={onHeadClick}>
        <span>{title}</span>
        <span className={`icon icon-plus ${styles.plus}`} />
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default AccordionItem;
